/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ClientListItem, GetClientDetailsApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClientDetails: build.query<ClientListItem, GetClientDetailsApiArg>({
      query: (queryArg) => ({ method: 'GET', url: `/v1/clients/${queryArg.clientId}` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getClientDetailsApi };
export const { useGetClientDetailsQuery, useLazyGetClientDetailsQuery } = injectedRtkApi;
